<template>
  <b-tabs fill>
    <b-tab
      active
    >
      <template #title>
        <GjIcon
          class="mr-50"
          name="Desktop"
        />
        {{ $tk('ClientPortal.Placement.Desktop') }}
      </template>
      <div
        class="col-md-12 border bg-white"
        style="height: 250px;"
      >
        <iframe
          id="desktop-preview"
          ref="desktopPreview"
          style="width:100%;height:100%;border:0px;"
        />
      </div>
    </b-tab>
    <b-tab>
      <template #title>
        <GjIcon
          class="mr-50"
          name="Mobile"
        />
        {{ $tk('ClientPortal.Placement.Mobile') }}
      </template>
      <div class="col-md-12">
        <div class="w-100 border bg-white">
          <iframe
            id="mobile-preview"
            ref="mobilePreview"
            style="width:100%;height:100%;border:0px;"
          />
        </div>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    template: {
      type: String,
      default: '',
    },
    properites: {
      type: Array,
      default: null,
    },
  },
  watch: {
    template() {
      this.setTemplate()
    },
  },
  mounted() {
    this.setTemplate()
  },
  methods: {
    setTemplate() {
      let value = this.template
      this.properites.forEach(x => {
        if (x.required && value.indexOf(`{{${x.propertyName}}}`) >= 0) value = value.split(`{{${x.propertyName}}}`).join(x.previewValue)
      })
      if (this.$refs.desktopPreview) {
        this.$refs.desktopPreview.srcdoc = value
        this.$refs.mobilePreview.srcdoc = `<div class="mobile">${value}</div>`
      }
    },
  },
}

</script>
